export enum EnumTiposMuWhatsapp {
    BOT = "41546",  
    API = "41547",
}
